export const isOfferHotels = (state) => state.offerHotels;
